import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Redirect } from 'react-router';
import { adminRoot } from 'Consts/advisorUris';
import useUserContext from 'Context/UserContext';
import { dashboardUri } from 'Consts/clientUris';


const styles = () => ({
  root: {},
  fields: {},
});

const NoopTemplate = () => {
  const { isAgent } = useUserContext();
  if (isAgent) {
    return <Redirect to={adminRoot} />;
  }
  return <Redirect to={dashboardUri} />;
};

NoopTemplate.defaultProps = {
};

NoopTemplate.propTypes = {
};

export default withStyles(styles)(NoopTemplate);
